import Section from "../Section";
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { IsTokenExpired } from "../../helpers/lib/jwt";
import { getBookings } from "../../helpers/lib/axios";
import { MoreHorizontalIcon } from "lucide-react";
import moment from 'moment';

const Bookings = () => {
    const navigate = useNavigate()
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [bookingsData, setBookingsData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const token = Cookies.get('noohraToken')
        if (!token) {
            navigate('/signup')
            return;
        }
        if (IsTokenExpired(token)) {
            Cookies.remove("noohraToken");
            navigate('/signup')
            return;
        } else {
            setLoading(true)
            getBookings().then(user => {
                setBookingsData(user?.data);
                setLoading(false)
            }).catch(err => console.log(err))
        }
    }, [navigate])

    // Calculate pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = bookingsData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(bookingsData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Handle edit button click
    const handleEdit = (service) => {
        setSelectedBooking(service);
        setIsModalOpen(true);
    };

    return (<>
        <BannerSectionStyle2
            bgUrl="/images/about/banner_bg.svg"
            imgUrl="/images/about/banner_img.png"
            title="Bookings"
            subTitle="Appointments information"
        />
        <Section
            topMd={170}
            topLg={150}
            topXl={110}
            bottomMd={200}
            bottomLg={150}
            bottomXl={110}
            className='flex justify-center items-center w-full'
        >
            <div className="lg:max-w-[70%] w-full mt-[5%] p-4">
                {/* Table */}
                <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
                    <table className="w-full text-sm text-left">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 font-medium text-gray-500">Name</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Email</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Gender</th>
                                <th className="px-6 py-3 font-medium text-gray-500">City</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Age</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Marital Status</th>
                                <th className="px-6 py-3 font-medium text-gray-500">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {loading ? (
                                // Show a loading indicator or skeleton rows when loading
                                <tr>
                                    <td colSpan={7} className="px-6 py-4 text-center">
                                        <div className="flex justify-center items-center">
                                            <svg
                                                className="animate-spin h-8 w-8 text-gray-500"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <circle
                                                    className="opacity-25"
                                                    cx="12"
                                                    cy="12"
                                                    r="10"
                                                    stroke="currentColor"
                                                    strokeWidth="4"
                                                ></circle>
                                                <path
                                                    className="opacity-75"
                                                    fill="currentColor"
                                                    d="M4 12a8 8 0 018-8v8H4z"
                                                ></path>
                                            </svg>
                                            <span className="ml-4 text-gray-500">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : currentItems.map((service) => (
                                <tr key={service._id} className="bg-white hover:bg-gray-50">
                                    <td className="px-6 py-4 whitespace-nowrap">{service?.userDetails?.name}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service?.userDetails?.email}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service?.userDetails?.gender}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        {service?.userDetails?.cityOfResidence}
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service?.userDetails?.age}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">{service?.userDetails?.maritalStatus}</td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <button
                                            onClick={() => handleEdit(service)}
                                            className="text-[#981D0E] hover:text-[#F5ABAB]"
                                        >
                                            <MoreHorizontalIcon className="h-5 w-5" />
                                        </button>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>

                {/* Edit Modal */}
                {isModalOpen && (
                    <div className="fixed z-[100000] inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-lg max-w-md w-full p-6">
                            <h2 className="text-xl font-semibold mb-4">Appointment Details</h2>
                            <div className="space-y-4">
                                {/* Complaint */}
                                <div className="flex flex-col gap-0 items-start ">
                                    <h3 className="text-lg font-medium text-gray-700 mb-1">Complaint</h3>
                                    <p className="text-gray-600 mt-0">
                                        {selectedBooking?.appointmentDetails?.complaint || "N/A"}
                                    </p>
                                </div>

                                {/* Duration */}
                                <div>
                                    <h3 className="text-lg font-medium text-gray-700 mb-1">Duration</h3>
                                    <p className="text-gray-600 mt-0">
                                        {selectedBooking?.appointmentDetails?.duration || "N/A"}
                                    </p>
                                </div>

                                {/* Expectations */}
                                <div>
                                    <h3 className="text-lg font-medium text-gray-700 mb-1">Expectations</h3>
                                    <p className="text-gray-600 mt-0">
                                        {selectedBooking?.appointmentDetails?.therapyExpectations || "N/A"}
                                    </p>
                                </div>

                                {/* Channel */}
                                <div>
                                    <h3 className="text-lg font-medium text-gray-700 mb-1">Channel</h3>
                                    <p className="text-gray-600 mt-0">
                                        {selectedBooking?.channel || "N/A"}
                                    </p>
                                </div>

                                {/* Date */}
                                <div>
                                    <h3 className="text-lg font-medium text-gray-700 mb-1">Date Created</h3>
                                    <p className="text-gray-600 mt-0">
                                        {moment(selectedBooking?.createdAt).format("YYYY-MM-DD hh:mm A") || "N/A"}
                                    </p>
                                </div>
                            </div>

                            <div className="mt-6 flex justify-end">
                                <button
                                    className="px-4 py-2 bg-[#981D0E] text-white rounded-md text-sm font-medium hover:bg-[#F5ABAB]"
                                    onClick={() => setIsModalOpen(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>

                )}
                <div className="flex items-center justify-between mt-4">
                    <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border border-gray-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                    >
                        Previous
                    </button>

                    <div className="flex items-center gap-2">
                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => handlePageChange(index + 1)}
                                className={`px-3 py-1 rounded text-sm font-medium ${currentPage === index + 1
                                    ? 'bg-[#981D0E] text-white'
                                    : 'border border-gray-300 hover:bg-gray-50'
                                    }`}
                            >
                                {index + 1}
                            </button>
                        ))}
                    </div>

                    <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border border-gray-300 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                    >
                        Next
                    </button>
                </div>
            </div>

        </Section>
    </>);
}

export default Bookings;